// extracted by mini-css-extract-plugin
export default {"about":"About_about__ALw2-","about-container":"About_about-container__q3Xbh","description":"About_description__sBuos","image":"About_image__l-PLo","values":"About_values__ytSlw"};